@use "../../../styles/mixins";

.container {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.header {
  overflow-y: auto;
  display: flex;
  flex-flow: row wrap;
  flex-shrink: 0;

  max-height: 20rem;
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid var(--color-borders);

  :global(.input-group) {
    flex-grow: 1;
    margin-bottom: 0;
  }

  :global(.form-control) {
    height: 2rem;
    padding: 0;
    border: none;
    border-radius: 0;

    box-shadow: none !important;
  }
}

.islandHeader {
  overflow-y: auto;
  display: flex;
  flex-flow: row wrap;
  flex-shrink: 0;

  max-height: 16.5rem;
  padding-bottom: 0;
}

.pickerCategoryTitle {
  margin-bottom: 0.5rem;
  padding-inline: 0.5rem;
  font-weight: var(--font-weight-medium);
  color: var(--color-text-secondary);

  &:not(:first-child) {
    margin-top: 0.375rem;
    padding-top: 0.5rem;
    border-top: 1px solid var(--color-borders);
  }
}

.sectionHeader {
  margin: 0;
  padding: 0.75rem 0.25rem 0.5rem;

  font-size: 0.75rem;
  font-weight: var(--font-weight-medium);
  color: var(--color-text-secondary);
}

.peerChip {
  max-width: calc(50% - 0.5rem);
  margin-bottom: 0.5rem;
}

.pickerList {
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  flex-grow: 1;
}

.padded {
  scrollbar-gutter: stable;
  padding: 0.5rem;

  @include mixins.adapt-padding-to-scrollbar(0.5rem);

  @media (max-width: 600px) {
    padding-inline: 0;
  }
}

.islandList {
  overflow: hidden;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;

  min-height: 0;
  padding: 0;
}

.noResults {
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;
  margin: 0;
  padding: 1rem 1rem;

  color: var(--color-text-secondary);
}

.onlineStatus {
  color: var(--color-primary);
}
